import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, timeout } from 'rxjs/operators';

import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private isDevelopment = !environment.production ? true : false; // 検証フラグ
  private defaultTimeout = 20000; // タイムアウトのデフォルト値

  constructor(private http: HttpClient) {}

  /**
   * postパラメータを取得、Observableを返す
   * @param path - apiパス
   * @param body - リクエストボディ
   */
  public post(
    path: string,
    body: Object = {},
    time: number = this.defaultTimeout,
  ): Observable<any> {
    // POST通信のObservableを返す
    return this.http.post(`${environment.apiUrl}${path}`, body).pipe(
      timeout(time),
      tap(() => this.developConsole(this.isDevelopment, path)),
    );
  }

  // API接続にメッセージを表示(開発環境のみ)
  private developConsole(isDevelopment: boolean, apiPath: string) {
    if (isDevelopment) {
      console.log(`${apiPath} API callback.`);
    }
  }
}
